module.exports = __webpack_public_path__ + "img/user-cicle.41c91614.png";